// extracted by mini-css-extract-plugin
module.exports = {"root":"HTTPError__root--Cgj4v","background":"HTTPError__background--Dk6AN","text":"HTTPError__text--2-s3r"};